export default class UpdateAccountRequest {
    name: string = '';
    inboundOverrideTransactionReference: string;
    outboundOverrideTransactionReference: string;
    reviewDateUtc: Date;
}